export enum ProductSize {
  HARDCOVER_STANDARD = "HARDCOVER_STANDARD",
  POCKET_SIZED = "POCKET_SIZED",
  OVERSIZED = "OVERSIZED",
  A4 = "A4",
  CHILDRENS_BOOK = "CHILDRENS_BOOK",
}

export enum ProductType {
  HARDCOVER = "HARDCOVER",
  PAPERBACK = "PAPERBACK",
}

export enum ProductStatus {
  PAUSE = "PAUSE",
  PROCESS = "PROCESS",
  DELETE = "DELETE",
}

export enum ProductCollection {
  FICTION = "FICTION",
  FANTASY = "FANTASY",
  MYSTERY = "MYSTERY",
  BIOGRAPHY = "BIOGRAPHY",
  SELF_HELP = "SELF_HELP",
  SCIENCE_FICTION = "SCIENCE_FICTION",
  HISTORY = "HISTORY",
  CHILDREN = "CHILDREN",
  OTHER = "OTHER",
}
